"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUnifiedicons = require("@bit/gerenciatd.unifiedicons.svg-icon");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var pathSolid = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M19.387,6.255a7.49,7.49,0,0,1-1.795,1.85q.011.155.011.465a10.162,10.162,0,0,1-.421,2.875A10.384,10.384,0,0,1,15.9,14.2a10.841,10.841,0,0,1-2.044,2.332A9.085,9.085,0,0,1,11,18.148a10.481,10.481,0,0,1-3.578.6,9.938,9.938,0,0,1-5.495-1.606,7.706,7.706,0,0,0,.864.044A7.007,7.007,0,0,0,7.234,15.66a3.587,3.587,0,0,1-3.346-2.482,4.544,4.544,0,0,0,.676.055,3.71,3.71,0,0,0,.942-.122A3.523,3.523,0,0,1,3.45,11.877,3.456,3.456,0,0,1,2.635,9.6V9.556a3.544,3.544,0,0,0,1.617.454A3.572,3.572,0,0,1,3.09,8.736a3.587,3.587,0,0,1,.056-3.512A10.143,10.143,0,0,0,6.408,7.867a9.974,9.974,0,0,0,4.116,1.1,3.972,3.972,0,0,1-.089-.82,3.575,3.575,0,0,1,3.578-3.578A3.45,3.45,0,0,1,16.628,5.7,7.02,7.02,0,0,0,18.9,4.837a3.475,3.475,0,0,1-1.573,1.972,7.134,7.134,0,0,0,2.06-.554Z",
    transform: "translate(-1.927 -4.571)"
  })
});

var Twitter = function Twitter(props) {
  var kind = props.kind;
  var path = null;

  switch (kind) {
    default:
      path = pathSolid;
  }

  var viewBox = props.viewBox,
      mainDimension = props.mainDimension;

  if (!viewBox) {
    viewBox = '0 -1 18 16';
  }

  if (!mainDimension) {
    mainDimension = 'x';
  }

  var Icon = (0, _gerenciatdUnifiedicons.CreateSvgIcon)(path, "Twitter-".concat(kind));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, _objectSpread(_objectSpread({}, props), {}, {
    viewBox: viewBox,
    mainDimension: mainDimension
  }));
};

var _default = Twitter;
exports["default"] = _default;

//# sourceMappingURL=index.js.map